import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

import { FormField } from '../interfaces/form';

@Injectable()
export class FormService {
  constructor(private _fb: FormBuilder) {}

  public getFormGroup(fields: Array<FormField>): Observable<FormGroup> {
    return new Observable((observer) => {
      const formControls: any = {};

      fields.forEach((field) => {
        const formControl = [];
        formControl.push(field.value ? field.value : '');

        if (field.validation && Object.keys(field.validation).length) {
          const validations = [];

          Object.keys(field.validation).forEach((valKey) => {
            if (valKey === 'required' && field.validation[valKey]) {
              validations.push(Validators.required);
            } else if (valKey === 'maxLength' && field.validation[valKey] > 0) {
              validations.push(Validators.maxLength(field.validation[valKey]));
            } else if (valKey === 'pattern' && field.validation[valKey] instanceof RegExp && !field.multiple) {
              validations.push(Validators.pattern(field.validation[valKey]));
            } else if (valKey === 'email') {
              validations.push(Validators.pattern(field.email));
            }
          });

          formControl.push(validations);
        }

        formControls[field.name] = formControl;
      });

      observer.next(this._fb.group(formControls));
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/form.service.ts